import BaseInput from './BaseInput';

export default BaseInput;
